import { client } from "./client";
import * as token from "./token";

// Variável para evitar múltiplas tentativas de refresh simultâneas
let refreshPromise = null;

export const refreshToken = async () => {
  // Se já existe uma tentativa de refresh em andamento, retornar ela
  if (refreshPromise) {
    console.log('⏳ Refresh already in progress, waiting...');
    return refreshPromise;
  }

  const refreshTokenValue = token.getRefreshToken();
  
  if (!refreshTokenValue) {
    throw new Error('No refresh token available');
  }

  console.log('🔄 Starting token refresh...');

  // Criar promise de refresh
  refreshPromise = (async () => {
    try {
      const response = await client.post("/sessions/refresh", {
        refresh_token: refreshTokenValue
      });

      if (response.data && response.data.token) {
        console.log('✅ Token refresh successful');
        
        // Atualizar tokens no storage
        token.setTokenData({
          token: response.data.token,
          refresh_token: response.data.refresh_token,
          expires_at: response.data.expires_at
        });

        return response.data.token;
      } else {
        throw new Error('Invalid refresh response');
      }
    } catch (error) {
      console.error('❌ Token refresh failed:', error);
      
      // Se o refresh falhou, limpar todos os tokens
      token.destroy();
      throw error;
    } finally {
      // Limpar promise de refresh
      refreshPromise = null;
    }
  })();

  return refreshPromise;
};

// Verifica se precisa fazer refresh e o faz automaticamente
export const ensureValidToken = async () => {
  if (token.isExpired()) {
    const refreshTokenValue = token.getRefreshToken();
    if (refreshTokenValue) {
      try {
        return await refreshToken();
      } catch (error) {
        console.error('Failed to refresh token:', error);
        // Redirecionar para login se necessário
        if (window.location.pathname !== '/login') {
          window.location.href = '/login';
        }
        throw error;
      }
    } else {
      // Sem refresh token, redirecionar para login
      if (window.location.pathname !== '/login') {
        window.location.href = '/login';
      }
      throw new Error('Token expired and no refresh token available');
    }
  }
  
  return token.get();
};